import angular from 'angular'
import vehicleInfoPage from './view/vehicleInfo.html'

class vehicleInfoCtrl {
    constructor($scope, httpRequest, sweetalert) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                allStr: '',
            },
        }

        $scope.queryList = function queryList() {
            httpRequest.post_getVehicleTypeList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()
        $scope.importconfig = {
            code: 'VEHICLE_TYPE',
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            callback() {
                $scope.queryList()
            },
        }
        $scope.upload = function upload() {
            const msg = '导入后将全面覆盖已有的车辆种类列表，确定要导入吗？'
            sweetalert.confirm('确认上传', msg).then(() => {
                angular.element('#J_uploadFiles .j-importexcel').click()
            }, () => {})
        }
    }
}
vehicleInfoCtrl.$inject = ['$scope', 'httpRequest', 'sweetalert']
export default angular.module('system.basedata.vehicleInfoTab.vehicleInfo', [])
    .controller('vehicleInfoCtrl', vehicleInfoCtrl)
    .component('vehicleInfo', {
        template: vehicleInfoPage,
        controller: 'vehicleInfoCtrl',
    }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/vehicleInfo/vehicleInfoListComponent.js